export default "__VITE_ASSET__DuNDgXw1__"